import * as React from "react";
import { BarChart } from "echarts/charts";
import { AriaComponent, GridComponent, TooltipComponent } from "echarts/components";
import * as echarts from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";

import { useDateFormatter } from "@/hooks/useDateFormatter";
import type { SpendReportTrendPoint } from "@/types/spend";
import { useEChart } from "../../components/use-echart";
import { PANEL_CLASS } from "../report-styles";
import { buildReportTrendOption } from "./report-trend-chart-options";

echarts.use([BarChart, AriaComponent, GridComponent, TooltipComponent, CanvasRenderer]);

interface Props {
  title: string;
  subtitle: string;
  trend: SpendReportTrendPoint[];
  selectedMonth: string;
  idLabel: string;
}

export const ReportTrendChart = ({ title, subtitle, trend, selectedMonth, idLabel }: Props) => {
  const { formatMonthYear } = useDateFormatter();
  const ref = useEChart(
    React.useMemo(
      () => buildReportTrendOption(trend, selectedMonth, idLabel, formatMonthYear),
      [formatMonthYear, idLabel, selectedMonth, trend],
    ),
  );
  return (
    <section className={PANEL_CLASS} aria-label={title}>
      <header className="border-b border-spend-row px-5 py-4">
        <h3 className="text-sm font-semibold text-spend-ink">{title}</h3>
        <p className="text-xs text-gray-500">{subtitle}</p>
      </header>
      <div className="px-3 pb-2">
        <div ref={ref} className="h-[260px] w-full" role="img" aria-label={`${title} chart`} />
      </div>
    </section>
  );
};
